import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  const paragraphs = aboutData.description.split('\n\n');

  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">关于我们</h2>
          <p className="mt-2 text-sm text-foreground-500">{aboutData.subtitle}</p>
        </div>
        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-5 gap-8 md:gap-12 items-start">
            <div className="md:col-span-3">
              {paragraphs.map((p, idx) => (
                <p key={idx} className="text-sm text-foreground-600 leading-relaxed mb-4">{p}</p>
              ))}
            </div>
            <div className="md:col-span-2">
              <div className="bg-background-100 rounded-xl p-6 border border-background-200/60">
                <h3 className="text-base font-semibold text-foreground-900 mb-4">平台优势</h3>
                <div className="space-y-4">
                  {aboutData.features.map((feat, idx) => (
                    <div key={idx} className="flex items-center gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100">
                        <i className={`${feat.icon} text-primary-500 text-lg`}></i>
                      </div>
                      <span className="text-sm font-medium text-foreground-700">{feat.label}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}